import { AccountActionTypes, AccountState, LOGOUT, SET_ACCOUNT_IS_LOADING, UPDATE_ACCOUNT } from "./types";

const initialState: AccountState = {
	account: undefined,
	isLoading: false,
};

export function accountReducer(state = initialState, action: AccountActionTypes): AccountState {
	switch (action.type) {
		case UPDATE_ACCOUNT:
			return Object.assign({}, state, {
				account: action.payload,
				isLoading: false,
			});
		case SET_ACCOUNT_IS_LOADING:
			return Object.assign({}, state, {
				isLoading: action.payload,
			});
		case LOGOUT:
			return Object.assign({}, state, {
				account: undefined,
			});
		default:
			return state;
	}
}
